import { useQuery } from '@tanstack/react-query'
import { getConversationStats } from '@/api/stats'

type UseConversationStatsProps = {
  startDate: string
  endDate: string
  courseName?: string
  enabled?: boolean
}

const useConversationStats = ({ startDate, endDate, courseName, enabled = true }: UseConversationStatsProps) => {
  return useQuery({
    queryKey: ['conversation-stats', startDate, endDate, courseName],
    queryFn: ({ signal }) => getConversationStats(startDate, endDate, courseName, signal),
    enabled: enabled && Boolean(startDate && endDate),
    retry: 1,
  })
}

export default useConversationStats
